import axios from 'axios'
import { ID } from '../../../../../_metronic/helpers'
import {
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  ResponseObjectUpload,
  ResponseObjectUploadId,
  ResponseObjectUploadPercent,
} from '../../../models'
import { GetFilterHistory, HistoryFilterModel } from '../features/guests/model'
import { ObjectIdModule } from '../features/modules/models'
import {
  AssignReserve,
  BedBookingModel,
  BedsBookingDto,
  BookingDetailUpload,
  BookingDetailUploadLog,
  BookingDocumentModel,
  BookingModel,
  BookingNoteModel,
  GetBedsBookingFilter,
  GetBookingDetailUploadFilter,
  GetBookingDocumentFilter,
  GetBookingDto,
  GetBookingNoteFilter,
  GetBookingShowDetailUploadFilter,
  PostListBedColumn,
  PostListBedDto,
} from '../models/booking.model'
import {
  RetiredGuestColumnModel,
  RetiredGuestFilterModel,
} from '../features/guests/model/retired.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createBookingService(dto: BookingModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/reserve/createReserve`, dto)
}

export async function deleteBookingService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<BookingModel>>(`${BASEURL}/reserve/deleteReserve`, {
    data: dto,
  })
}

export async function deleteBookingBedService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<BookingModel>>(`${BASEURL}/reserve/deleteReserveBed`, {
    data: dto,
  })
}

export function getBookingService(dto: GetBookingDto) {
  return axios.post<ResponseObjectPaginated<BookingModel[]>>(`${BASEURL}/reserve/getList`, dto)
}

export function getBedsFromBookingService(dto: PostListBedDto) {
  return axios.post<ResponseObjectPaginated<PostListBedColumn[]>>(
    `${BASEURL}/reserve/postListBeds`,
    dto,
  )
}

export function getBedsFromBookingService2(dto: GetBedsBookingFilter) {
  return axios.post<ResponseObjectPaginated<BedBookingModel[]>>(
    `${BASEURL}/reserve/postListBeds2`,
    dto,
  )
}

export function updateReserveGuestBed(dto: BedsBookingDto) {
  return axios.post<ResponseObject<BookingModel>>(`${BASEURL}/reserve/updateReserveGuestBed`, dto)
}

export function updateReserveDetail(dto: any) {
  return axios.post<ResponseObject<BookingModel>>(`${BASEURL}/reserve/updateReserveDetail`, dto)
}

export function getTemplateBookingService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/reserve/downloadTemplateBulkLoadStandar`)
}

export function uploadTemplateBookingService(test: any, id: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/bulkLoadStandar?bulkLoadId=${id}`,
    test,
    {
      timeout: 360000,
    },
  )
}

export function getTemplateBookingSummaryService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/reserve/downloadTemplateBulkLoadSummary`)
}

export function uploadTemplateBookingSummaryService(test: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/reserve/bulkLoadSummary`, test, {
    timeout: 360000,
  })
}

export function getListBulkLoadTrayService(dto: GetBookingDetailUploadFilter) {
  return axios.post<ResponseObjectPaginated<BookingDetailUpload[]>>(
    `${BASEURL}/reserve/getListBulkLoadTray`,
    dto,
  )
}

export function getListBulkLoadLogTrayService(dto: GetBookingShowDetailUploadFilter) {
  return axios.post<ResponseObjectPaginated<BookingDetailUploadLog[]>>(
    `${BASEURL}/reserve/getListBulkLoadTrayDetail`,
    dto,
  )
}

export function reserveChangeService(dto: AssignReserve) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/reserve/ReserveChangeState`, dto)
}

//NOTES

export function getBookingNotesService(dto: GetBookingNoteFilter) {
  return axios.post<ResponseObjectPaginated<BookingNoteModel[]>>(
    `${BASEURL}/reserve/getListNotes`,
    dto,
  )
}

export async function createBookingNotesService(dto: BookingNoteModel) {
  return await axios.post<ResponseObject<BookingNoteModel>>(
    `${BASEURL}/reserve/createReserveNotes`,
    dto,
  )
}

export async function editBookingNotesService(dto: BookingNoteModel) {
  return await axios.post<ResponseObject<BookingNoteModel>>(
    `${BASEURL}/reserve/editReserveNotes`,
    dto,
  )
}
export async function deleteBookingNotesService(id: ID) {
  return await axios.delete<ResponseObject<BookingModel>>(
    `${BASEURL}/reserve/deleteReserveNotes?NotaId=${id}`,
  )
}

export function getBookingDocumentsService(dto: GetBookingDocumentFilter) {
  return axios.post<ResponseObjectPaginated<BookingDocumentModel[]>>(
    `${BASEURL}/reserve/getListDocuments`,
    dto,
  )
}

export async function createBookingDocumentsService(test: any, bookingId: ID) {
  return await axios.post<ResponseObject<BookingDocumentModel>>(
    `${BASEURL}/reserve/createReserveDocuments?ReservaId=${bookingId}`,
    test,
  )
}

export async function deleteBookingDocumentsService(id: ID) {
  return await axios.delete<ResponseObject<BookingDocumentModel>>(
    `${BASEURL}/reserve/deleteReserveDocuments?DocumentoId=${id}`,
  )
}

export function getBookingDocumentService(id: ID) {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/reserve/downloadReserveDocuments?DocumentoId=${id}`,
  )
}

export function getBookingDocumentServiceV(id: ID) {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadReserveDocuments_file?DocumentoId=${id}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function sendEmailCheckInOutService(id: ID, tipo: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/sendMailCheckInOut?reservaCamaId=${id}&tipo=${tipo}`,
  )
}

export function downloadPDFCheckInOutService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/downloadPDFCheckInOut`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function downloadPDFPreCheckInListService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/downloadPDFPreCheckInList`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function getListHostingHistoryService(dto: GetFilterHistory) {
  return axios.post<ResponseObjectPaginated<HistoryFilterModel[]>>(
    `${BASEURL}/reserve/getListHostingHistory`,
    dto,
  )
}

export function getListHostingHistoryExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/getListHostingHistoryExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getLast10BedsUsedByGuestService(dto: any) {
  return axios.post<any>(
    `${BASEURL}/reserve/getLast10BedsUsedByGuest`,
    dto,
  )
}

export function getLast10PersonsByBedService(dto: any) {
  return axios.post<any>(
    `${BASEURL}/reserve/getLast10PersonsByBed`,
    dto,
  )
}

export function getListCheckInExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/getListCheckInExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getListCheckOutExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/getListCheckOutExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getListBookingExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/getListExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

// ------------------------ MASIVE LOAD -----------------------------

export function getTemplateStandardBookingService() {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadTemplateBulkLoadStandar_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function getTemplateSummaryBookingService() {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadTemplateBulkLoadSummary_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function getTemplateCheckinService() {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadTemplateBulkLoadCheckIn_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

/** Enlace directo a la plantilla: …/hoteleria/backend/Templates/CargaMasiva/PLANTILLA_REIMPRESION_CHECKIN.xlsx */
export function getPlantillaReimpresionCheckinMasiveDownloadUrl(): string {
  const base = BASEURL?.endsWith('/') ? BASEURL : `${BASEURL}/`
  return new URL(
    '../Templates/CargaMasiva/PLANTILLA_REIMPRESION_CHECKIN.xlsx',
    base,
  ).href
}

export function downloadMasiveCheckinService(listIds: string[]) {
  return axios.post<any>(`${BASEURL}/reserve/downloadPDFListCheckIn`, listIds, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function getTemplateCheckoutService() {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadTemplateBulkLoadCheckOut_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadTemplateBooking(test: any) {
  // --- segundo
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/bulkLoadStandar`,
    { test },
    {
      timeout: 360000,
    },
  )
}

export function getLoadPercentage(id: string) {
  return axios.get<ResponseObjectUploadPercent>(
    `${BASEURL}/bulkLoad/getBulkLoad_Progress?bulkLoadId=${id}`,
  )
}

export function getLoadMasiveId() {
  // --- primer servicio para obtener el id a asociar al archivo
  return axios.get<ResponseObjectUploadId>(`${BASEURL}/bulkLoad/getBulkLoad_Id`)
}

export function uploadTemplateCheckinAsyncService(test: any, id: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/bulkLoadCheckIn_async?bulkLoadId=${id}`,
    test,
    {
      timeout: 360000,
    },
  )
}

export function postDownloadPDFReimpresionCheckInPorDnisExcelService(formData: FormData) {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadPDFReimpresionCheckInPorDnisExcel`,
    formData,
    {
      timeout: 360000,
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf, application/json, */*',
      },
    },
  )
}

export function uploadTemplateCheckoutAsyncService(test: any, id: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/bulkLoadCheckOut_async?bulkLoadId=${id}`,
    test,
    {
      timeout: 360000,
    },
  )
}

export function bookingByGuest(dto: PostListBedDto) {
  return axios.post<ResponseObjectPaginated<PostListBedColumn[]>>(
    `${BASEURL}/reserve/getReservationsByGuestId`,
    dto,
  )
}

export function getListComboHuespedService(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(
    `${BASEURL}/reserveInPerson/getListComboHuesped`,
    {},
    { params: dto },
  )
}

export function getHuespedEsRelevoService(dto: any) {
  return axios.post<ResponseObject<any>>(
    `${BASEURL}/reserveInPerson/HuespedEsRelevo`,
    {},
    { params: dto },
  )
}

export function getModuleRelevoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(
    `${BASEURL}/reserveInPerson/getModuleRelevo`,
    {},
    { params: dto },
  )
}

export function getRoomRelevoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(
    `${BASEURL}/reserveInPerson/getRoomRelevo`,
    {},
    { params: dto },
  )
}

export function getBedRelevoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(
    `${BASEURL}/reserveInPerson/getBedRelevo`,
    {},
    { params: dto },
  )
}

export function getEstadoCamaService(dto: any) {
  return axios.post<ResponseObject<any>>(
    `${BASEURL}/reserveInPerson/GetEstadoCama`,
    {},
    { params: dto },
  )
}

export function getUltimaCamaUsadaDisponibleService(dto: any) {
  return axios.post<ResponseObject<any>>(
    `${BASEURL}/reserveInPerson/GetUltimaCamaUsadaDisponible`,
    {},
    { params: dto },
  )
}

export function getModuloByEstadoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/GetModuloByEstado`,
    {},
    { params: dto },
  )
}

export function getHabitacionesByEstadoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/GetHabitacionesByEstado`,
    {},
    { params: dto },
  )
}

export function getCamasByEstadoService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/GetCamasByEstado`,
    {},
    { params: dto },
  )
}

export function getCamaOcupadaPorHuespedService(dto: any) {
  return axios.post<ResponseObject<any>>(
    `${BASEURL}/reserveInPerson/GetCamaOcupadaPorHuesped`,
    {},
    { params: dto },
  )
}
// MASIVE CHECKIN PRINTING

export function getTemplateCheckinPrintingService(bookingId: string) {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadPDFReserveCheckIn?reservaId=${bookingId}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadTemplateBookingCheckinPrintingService(test: any, id: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/bulkLoadStandar_ReserveCheckIn?bulkLoadId=${id}`,
    test,
    {
      timeout: 360000,
    },
  )
}

export function createReserveCheckInService(dto: any) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserveInPerson/CreateReserveCheckIn`, dto)
}

export function createReserveCheckInBatchService(dto: any) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserveInPerson/CreateReserveCheckIn_batch`, dto)
}

export function createCheckOutReserveService(dto: any) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserve/createCheckOutReserve`, dto)
}

export function getTemplatePrintingCheckinService() {
  return axios.post<any>(
    `${BASEURL}/reserve/downloadTemplateBulkLoadCheckInPrint`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function getModuloDisponibleService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/getModulosDisponible`,
    {},
    { params: dto },
  )
}
export function getHabitacionesDisponibleService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/getHabitacionesDisponible`,
    {},
    { params: dto },
  )
}

export function getCamasDisponibleService(dto: any) {
  return axios.post<ResponseObjectPaginated<any>>(
    `${BASEURL}/reserveInPerson/getCamasDisponible`,
    {},
    { params: dto },
  )
}

export function getDataHuespedPopup(nroDocumento: string) {
  return axios.post<ResponseObject<any>>(
    `${BASEURL}/reserveInPerson/GetDataHuespedPopup`,
    {},
    { params: { nrodocumento: nroDocumento } },
  )
}

// Huespedes retirados

export function getRetiredGuestsService(dto: RetiredGuestFilterModel) {
  return axios.post<ResponseObjectPaginated<RetiredGuestColumnModel[]>>(
    `${BASEURL}/reserveInPerson/getList_RESpresencialesCheckout`,
    dto,
  )
}

export function getListNoShowService() {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserve/getListNoShow`, {})
}

export function cancelNoShowReserveService() {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserve/cancelNoShowReserve`, {})
}

// CARGOS
export function getListCargosService() {
  return axios.post<ResponseObject<any[]>>(`${BASEURL}/reserve/getListCargos`, {})
}

export function createCargoService(dto: { nombre: string }) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/reserve/createCargo`, dto)
}

// REPORTE DE CAMAS PREFERENTES
export function getListCamasPreferentesService(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(`${BASEURL}/reserve/getListCamasPreferentes`, dto)
}

export function downloadCamasPreferentesExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/reserve/downloadCamasPreferentesExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}
